export default __webpack_public_path__ + "static/media/css.9f33c557.png";